<!--
/**
* @name: List.vue
* @description: 角色管理
* @author: 于海威
* @create: 2020/08/07 17:52:23
* @update: 2020/08/07 17:52:23
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query @search="onSearch" spaceBetween searchText="查询">
      <y-query-item>
        <k-input placeholder="请输入角色名称" v-model="para.name" clearable></k-input>
      </y-query-item>
      <y-query-item slot="append">
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onAddRole">新建</y-button>
      </y-query-item>
    </y-query>
    <k-table :data="roleList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()" hasIndex></k-table>
    <k-pagination :total="total" v-if="roleList && roleList.length" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_DELETE,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_DISABLED,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_ENABLED,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_PAGE,
} from "@/assets/modules/apiList";

const initPara = () => ({
  name: "",
  pageSize: 15,
  pageCurrent: 1,
});

export default {
  data() {
    return {
      roleList: [],
      total: 0,
      para: initPara(),
      isLoading: false,
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "角色ID",
          field: "id",
        },
        {
          name: "角色名称",
          field: "name",
        },
        {
          name: "角色描述",
          field: "description",
          style: {
            "white-space": "normal",
            "line-height": "20px",
          },
        },
        {
          name: "启用状态",
          field: "",
          customRender: (row) => (
            <k-switch
              checked={row.isEnabled}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
          style: {
            width: 60,
          },
        },
        {
          name: "创建时间",
          field: "createTime",
        },
        {
          name: "操作",
          customRender: (row) => {
            const viewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                查看
              </a>
            );
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            const deleteButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDelete(row);
                }}
              >
                删除
              </a>
            );
            return (
              <div>
                {viewButton}&#12288;{editButton}&#12288;{deleteButton}
              </div>
            );
          },
        },
      ];
    },
    getRoleList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_PAGE,
        para,
      }).then((res) => {
        this.roleList = res.pageList || [];
        this.total = res.total;
      });
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getRoleList();
    },
    onReset() {
      this.para = initPara();
      this.getRoleList();
    },
    onAddRole() {
      this.$controller.open({
        name: "roleAdd",
        query: {
          refresh: new Date() - 0,
        },
      });
    },
    onView(row) {
      const { id } = row;
      this.$controller.open({
        name: "roleAdd",
        query: {
          refresh: new Date() - 0,
          id,
          view: 1,
        },
        title: "查看角色",
      });
    },
    onEdit(row) {
      const { id } = row;
      this.$controller.open({
        name: "roleAdd",
        query: {
          refresh: new Date() - 0,
          id,
          edit: 1,
        },
        title: "编辑角色",
      });
    },
    onDelete(row) {
      const { id } = row;
      this.$dialog({
        title: "提示",
        content: "是否确认删除该角色？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_DELETE,
            para: { id },
          })
            .then(() => {
              this.isLoading = false;
              this.getRoleList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onChangeStatus(row) {
      const { id, isEnabled } = row;
      let api = "";
      if (isEnabled) {
        api = NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_DISABLED;
      } else {
        api = NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_ENABLED;
      }
      this.$dialog({
        title: "提示",
        content: `是否确认${isEnabled ? "停用" : "启用"}该角色？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api,
            para: { id },
          })
            .then(() => {
              this.isLoading = false;
              this.getRoleList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onSearch() {
      if (this.para.name.replace(/\s*/, "").length < 1) {
        return this.$root.tip("请输入角色名称");
      }
      this.para.pageCurrent = 1;
      this.getRoleList();
    },
  },
  created() {
    this.getRoleList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getRoleList();
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
